module.exports = __webpack_public_path__ + "images/category_lp/brand/assessment_achievements/1_01061d76eed7b63235c5e93be6bdba6a.jpg";